import { Label } from "@api/graphql/generated/generated-types";

export function sortLabelsByName(labels: Label[]): Label[] {
  return [...labels].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
  );
}

export function filterLabelsBySearchTerm(
  labels: Label[],
  searchTerm: string
): Label[] {
  const trimmedSearchTerm = searchTerm.trim().toLowerCase();
  if (!trimmedSearchTerm) return labels;
  return labels.filter((label) =>
    label.name.toLowerCase().includes(trimmedSearchTerm)
  );
}

export function filterAvailableLabels(
  allLabels: Label[],
  assignedLabels: Label[]
): Label[] {
  return allLabels.filter(
    (label) => !assignedLabels.some((assigned) => assigned.id === label.id)
  );
}

export function isLabelAssigned(
  labelId: string,
  assignedLabels: Label[]
): boolean {
  return assignedLabels.some((label) => label.id === labelId);
}
